import { render, staticRenderFns } from "./TeamTabelle.vue?vue&type=template&id=236180c4&scoped=true&"
import script from "./TeamTabelle.vue?vue&type=script&lang=js&"
export * from "./TeamTabelle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "236180c4",
  null
  
)

export default component.exports